import { Typography } from "@/react/components/shared/uikit/Typography";
import type { CheckoutContextProps } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { DETAILED_BACKGROUND_COLOR } from "@/react/helpers/paywallCustomizationHelpers";

import { CoverImage } from "../Detailed/Cover/CoverImage";
import { OfferTemplate } from "../Detailed/OfferTemplate";
import { usePaywallCustomizationContext } from "../PaywallCustomizationProvider";

type CommonData = "paywall";
type PriceSelectorData =
  | "previewMutation"
  | "setSelectedPrice"
  | "isSelectedPrice"
  | "getSelectedPrice"
  | "couponPreviewMutation";

interface MediaBlockPropertiesProps {
  useHooks: () => Pick<CheckoutContextProps, CommonData | PriceSelectorData>;
}

export const MediaBlockProperties = ({
  useHooks,
}: MediaBlockPropertiesProps) => {
  const { paywallCustomization } = usePaywallCustomizationContext();
  const isEnabled = paywallCustomization?.media_block_properties?.enabled;
  const blocks =
    paywallCustomization?.media_block_properties?.media_blocks ?? [];

  if (!isEnabled || blocks.length === 0) {
    return null;
  }

  return (
    <>
      {blocks.map((block, index) => {
        const backgroundColor =
          block?.background_color ?? DETAILED_BACKGROUND_COLOR;

        const cover =
          block?.cover?.url != null ? (
            <CoverImage
              imageUrl={block.cover.url}
              imageClassName="rounded-2xl"
            />
          ) : null;

        const header = (
          <div className="flex flex-col md:w-[768px] items-center gap-y-5">
            <div className="flex flex-col gap-y-1 text-center">
              <Typography.TitleLg>{block?.title ?? ""}</Typography.TitleLg>
              <Typography.BodyMd color="text-secondary">
                {block?.description ?? ""}
              </Typography.BodyMd>
            </div>
          </div>
        );

        return (
          <OfferTemplate
            key={block.id || index}
            content={{
              backgroundColor,
              cover,
              header,
              shouldShowCountdown: false,
            }}
            useHooks={useHooks}
            shouldShowActions={false}
          />
        );
      })}
    </>
  );
};
